import React from "react"

function IconSalesforce({ color = "currentColor", color2, fontSize, height, ...props }) {
  return (
    <svg
      fill={color}
      fuze-icon="salesforce"
      viewBox="0 0 24 24"
      style={{ height: height || fontSize }}
      originalclass="fz-icon fz-icon-salesforce"
      {...props}
    >
      <path
        d="M7.32 4.8a4.466 4.466 0 0 0-4.467 4.463l.007.264c.016.263.054.522.115.775l.059.223-.107.087a3.976 3.976 0 0 0-1.4 3.034c0 2.189 1.76 3.966 3.932 3.966l.277-.01.052.098a4.187 4.187 0 0 0 3.658 2.153l.23-.006a4.186 4.186 0 0 0 3.179-1.75l.152-.233.08.024c.311.083.634.125.963.125l.24-.007a3.743 3.743 0 0 0 2.63-1.332l.152-.193.19.02c.108.006.215.01.323.01 2.7 0 4.888-2.206 4.888-4.924 0-2.719-2.187-4.926-4.888-4.926l-.295.009a4.843 4.843 0 0 0-.863.13l-.299.084-.092-.12c-.759-.922-1.899-1.48-3.165-1.534a2.66 2.66 0 0 0-.47.024c-.53.072-1.067.287-1.601.598l-.185.111a10.8 10.8 0 0 0-.172.11l-.088-.087A4.46 4.46 0 0 0 7.32 4.8zm0 1.31c1 0 1.919.463 2.514 1.241a.655.655 0 0 0 .943.102l.075-.061.2-.148a5.8 5.8 0 0 1 .406-.26c.4-.233.786-.388 1.12-.433.085-.012.164-.016.239-.013C13.89 6.583 14.813 7.13 15.3 8a.655.655 0 0 0 .838.278 3.536 3.536 0 0 1 1.446-.308c1.975 0 3.579 1.618 3.579 3.617 0 1.998-1.604 3.615-3.58 3.615-.236 0-.473-.024-.707-.07a.655.655 0 0 0-.698.322 2.438 2.438 0 0 1-3.195 1.005.655.655 0 0 0-.89.332 2.88 2.88 0 0 1-2.648 1.753 2.88 2.88 0 0 1-2.7-1.883.655.655 0 0 0-.749-.414 2.592 2.592 0 0 1-.538.056c-1.447 0-2.623-1.188-2.623-2.657 0-.961.508-1.832 1.316-2.304a.655.655 0 0 0 .27-.827 3.157 3.157 0 0 1 2.9-4.406z"
        fill={color}
        fillRule="evenodd"
        style={{ height: height || fontSize }}
        originalclass="__primary"
      />
    </svg>
  )
}

export default IconSalesforce
